import { render, staticRenderFns } from "./MmmmReasonDtlInput.vue?vue&type=template&id=4e2028a8&"
import script from "./MmmmReasonDtlInput.vue?vue&type=script&lang=js&"
export * from "./MmmmReasonDtlInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports